import { httpReauest } from "../utils/httpRequest";

export async function getUser(userId) {
  const res = await httpReauest("GET", "/user/info/" + userId, {}, {});
  if (res.status === 400) {
    localStorage.removeItem("user")
    window.location.href = window.origin
  }
  return res.data.data;
}
